module.exports = __webpack_public_path__ + "img/start-review-accept.3b2da61b.png";